import Head from 'next/head';
import { useRouter } from 'next/router';
import NavBar from '../nav/NavBar';
import WebdienstHeader from '../nav/WebdienstHeader';
import { FavIcons } from '../FavIcons';
import Footer from '../Footer';
import { SideBarNav } from '../nav/SideBarNav';
interface DefaultLayoutProps {
  children: React.ReactNode;
}

const DefaultLayout = ({ children }: DefaultLayoutProps) => {
  const route = useRouter();
  const allRoutes: boolean = route.pathname.includes('/');
  const heroCarousel: boolean = route.pathname.includes(
    '/components/hero-carousel'
  );
  const paasHeader: boolean = route.pathname.includes(
    '/basic-elements/webdienst-header'
  );

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <FavIcons />
      </Head>
      {route.pathname.includes('webdienst-header') ? (
        <WebdienstHeader />
      ) : (
        <NavBar styles="fixed-top" projectTitle="Bootstrap Styleguide V5" />
      )}

      {/* Default layout */}
      {allRoutes && heroCarousel === false && paasHeader == false && (
        <article className="container mt-6">
          <div className="row row-cols-lg-12">
            {/* LEFT COLUMM */}
            <aside className="d-none d-lg-block col-md-2">
              <SideBarNav />
            </aside>
            {/* CONTENT */}
            <div className="col-lg-10 col-12 order-1">{children}</div>
          </div>
        </article>
      )}

      {/* Hero Carousel */}
      {heroCarousel === true && (
        <article className={`container-fluid p-0 hero-carousel`}>
          {children}
        </article>
      )}

      {/* PAAS Header */}
      {paasHeader === true && (
        <article className={`container p-0 hero-carousel`}>
          <div className="row row-cols-lg-12">
            {/* LEFT COLUMM */}
            <aside className="d-none d-lg-block col-md-2">
              <SideBarNav />
            </aside>
            {/* CONTENT */}
            <div className="col-lg-10 col-12 order-1">{children}</div>
          </div>
        </article>
      )}
      <Footer />
    </>
  );
};

export default DefaultLayout;
